import { getSupabase } from '@/lib/supabase'
import { withAuthRecovery } from '@/lib/authRecovery'

// Быстрый снапшот безопасности ранбуков схлопывания договоров.
// Числа = то, что get_contract_runbook_snapshot() отдаёт из БД (read-only).
export type ContractRunbookSnapshot = {
  captured_at: string
  schema: string

  // 🔒 Сохраняемые величины (кроме contracts_* — те падают на число схлопнутых).
  contracts_total: number
  contracts_main: number
  royalty_charges_count: number
  royalty_charges_amount_rub: number
  royalty_charges_confirmed: number
  royalty_payments_count: number
  royalty_payments_amount_rub: number
  royalty_allocations_count: number
  royalty_allocations_amount_rub: number
  royalty_series_terms_count: number
  studio_documents_count: number
  studio_checklist_count: number
  staging_matched_count: number
  charges_orphaned: number
  payments_orphaned: number

  // 🎯 Инварианты.
  contract_amendments_total: number
  entity_change_events: number
  duplicate_main_pairs: number
  duplicate_main_pairs_entity_change: number
  inverted_contracts: number
}

export type ContractCoverageGapSummary = {
  captured_at: string
  window_from: string
  window_to: string
  revenue_at_risk: number
  uncovered_days: number
  days_without_ownership: number
  studios_affected: number
}

export async function loadContractRunbookSnapshot(
  schema = 'public'
): Promise<ContractRunbookSnapshot> {
  const supabase = getSupabase()
  const { data, error } = await withAuthRecovery(() =>
    (supabase as any).rpc('get_contract_runbook_snapshot', { p_schema: schema })
  )
  if (error) {
    console.error('Failed to load contract runbook snapshot:', error)
    throw error
  }
  return data as ContractRunbookSnapshot
}

export async function loadContractCoverageGapSummary(input?: {
  from?: string
  to?: string
}): Promise<ContractCoverageGapSummary> {
  const supabase = getSupabase()
  const { data, error } = await withAuthRecovery(() =>
    (supabase as any).rpc('get_contract_coverage_gap_summary', {
      p_from: input?.from ?? undefined,
      p_to: input?.to ?? undefined,
    })
  )
  if (error) {
    console.error('Failed to load contract coverage gap summary:', error)
    throw error
  }
  return data as ContractCoverageGapSummary
}
